import Grid from '@material-ui/core/Grid'
import React, { FC } from 'react'
import { HeroWrapper, TabbingNav } from './style'

//* utils
import { WrapperImage } from '../../../models/others/image'
import { TopicCTA } from '../../../models/topics/cta'
import ImgUtil from '../../../utils/img.utils'
import { internalLinkHandler } from '../../../utils/link.utils'
import formatInlineCode from '../../../utils/shortTextFormatting'

//* components
import Button from '../button'
import Typography from '../typography'

type Props = {
  data: {
    eyebrow?: string
    headline?: string
    heroTabSubheadline?: string
    cta?: TopicCTA[] | []
    tabs?: TopicCTA[] | []
    mainImage?: WrapperImage | null
  } | null
}

const HeroBanner: FC<Props> = ({ data }) => {
  if (!data) return null
  const imgUrl = data.mainImage?.image?.file?.url || ''

  const eyebrow = data.eyebrow ? (
    <Typography type="header5" className="eyebrow" data-cy="eyebrow">
      {formatInlineCode(data.eyebrow)}
    </Typography>
  ) : null

  const headline = data.headline ? (
    <Typography type="header1" className="heroHeading" data-cy="heroHeading">
      {formatInlineCode(data.headline)}
    </Typography>
  ) : null

  const heroTabSubheadline = data.heroTabSubheadline ? (
    <Typography type="body" className="subHeading font__inter" data-cy="subHeading">
      {formatInlineCode(data.heroTabSubheadline)}
    </Typography>
  ) : null

  const heroButtons = (
    <div className="heroButtons" data-cy="heroButtons">
      {data?.cta?.map((item, index) => (
        <Button
          key={index}
          text={item.text}
          icon={true}
          type={index === 0 ? 'primary' : 'secondary'}
          theme="light"
          href={item.internalLink ? internalLinkHandler(item.internalLink) : item.externalUrl}
        />
      ))}
    </div>
  )

  const tabs = (
    <TabbingNav data-cy="TabbingNav">
      <ul>
        {data.tabs?.map((item, idx) => (
          <li key={idx}>
            <a href={item.externalUrl}>{item.text}</a>
          </li>
        ))}
      </ul>
    </TabbingNav>
  )

  return (
    <>
      <HeroWrapper data-cy="HeroWrapper">
        <div
          className="hero__bg"
          style={{ backgroundImage: `url(${ImgUtil.getResizedImageUrl(imgUrl, '')})` }}></div>

        <Grid className="heroContent">
          {eyebrow}
          {headline}
          {heroTabSubheadline}

          <div className="heroButtons" data-cy="heroButtons">
            {heroButtons}
          </div>
        </Grid>
      </HeroWrapper>

      {data.tabs && tabs}
    </>
  )
}

export default HeroBanner
